module.exports = __webpack_public_path__ + "static/img/landing-c.f7204bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing-c.png
// module id = Pt9Y
// module chunks = 1